export const environment = {
    production: true,
    biocare: false,
    apiUrl: 'https://api.webaro.dev',
};
